import React, { useEffect, useState } from 'react';
import PageHeader from '../PageHeader';
import SearchBar from '../SearchBar';
import DateRangeFilter from '../DateRangeFilter';
import useDebounced from '../../hooks/useDebounced';

export default function DistributorActivityHeader({
  kind,
  t,
  headingRef,
  createAction,
  criteria,
  onFiltersChange,
  exporting,
  onExport,
  title,
  subtitle,
  filterAction,
  adminLayout = false,
}) {
  const [search, setSearch] = useState(criteria.search || '');
  const settledSearch = useDebounced(search, 300);
  const searchValue = search ? settledSearch.trim() : '';
  useEffect(() => {
    onFiltersChange({ search: searchValue });
  }, [searchValue, onFiltersChange]);
  return (
    <div className={adminLayout ? undefined : 'me-dw-activity-heading'}>
      <PageHeader
        headingRef={headingRef}
        title={
          title || (kind === 'orders' ? 'Orders' : kind === 'shipments' ? 'Shipments' : 'IVRs')
        }
        subtitle={
          subtitle ||
          (kind === 'orders'
            ? 'Create and track your orders.'
            : kind === 'shipments'
              ? 'Shipment statuses match their orders and update automatically.'
              : 'Submit and track your IVR requests.')
        }
      >
        <SearchBar
          className="w-[243px] max-w-full"
          placeholder={
            kind === 'orders'
              ? 'Search orders...'
              : kind === 'shipments'
                ? 'Order or tracking'
                : 'Search IVR details...'
          }
          label="Search"
          maxLength={200}
          value={search}
          onChange={(event) => setSearch(event.target.value)}
        />
        <DateRangeFilter
          label="Filter by date submitted (UTC)"
          dateFrom={criteria.dateFrom || ''}
          dateTo={criteria.dateTo || ''}
          onChange={onFiltersChange}
        />
        {kind === 'orders' && (
          <button
            type="button"
            disabled={exporting}
            onClick={onExport}
            className="me-dw-export w-[46px] h-[46px] border border-[#e2e8f0] rounded-[10px] shadow-sm bg-white flex items-center justify-center hover:bg-gray-50 transition-colors disabled:opacity-50"
            aria-label={t(exporting ? 'Exporting...' : 'Export orders')}
            title={t('Export orders')}
          >
            <span
              className="material-symbols-outlined text-[#64748b] text-[20px]"
              aria-hidden="true"
            >
              {exporting ? 'hourglass_empty' : 'download'}
            </span>
          </button>
        )}
        {filterAction}
        {createAction}
      </PageHeader>
    </div>
  );
}

// The embedded admin and shipment lists retain their existing explicit filter form.
export function DistributorActivityFilters({
  t,
  kind,
  inputs,
  changeInput,
  filtered,
  onSubmit,
  onClear,
}) {
  return (
    <form className="me-dw-activity-filters" onSubmit={onSubmit}>
      <label className="me-dw-activity-search">
        <span>{t(kind === 'shipments' ? 'Search order or tracking number' : 'Search')}</span>
        <input
          type="search"
          className="me-dw-field rounded-lg border px-3"
          maxLength={200}
          value={inputs.search || ''}
          onChange={(event) => changeInput('search', event.target.value)}
        />
      </label>
      <label>
        <span>{t('Created from (UTC)')}</span>
        <input
          type="date"
          className="me-dw-field rounded-lg border px-3"
          value={inputs.dateFrom || ''}
          max={inputs.dateTo || undefined}
          onChange={(event) => changeInput('dateFrom', event.target.value)}
        />
      </label>
      <label>
        <span>{t('Created through (UTC)')}</span>
        <input
          type="date"
          className="me-dw-field rounded-lg border px-3"
          value={inputs.dateTo || ''}
          min={inputs.dateFrom || undefined}
          onChange={(event) => changeInput('dateTo', event.target.value)}
        />
      </label>
      <button type="submit" className="me-dw-primary">
        {t('Apply filters')}
      </button>
      {filtered && (
        <button type="button" className="me-dw-link" onClick={onClear}>
          {t('Clear filters')}
        </button>
      )}
    </form>
  );
}
